import {
  Box,
  Flex,
  Heading,
  Text,
  Image,
  Button,
  SimpleGrid,
} from "@chakra-ui/react";
import brandingImg from "../../assets/portfolio/image2.png";
import marketingImg from "../../assets/portfolio/image3.png";
import websiteImg from "../../assets/portfolio/image4.png";
import applicationImg from "../../assets/portfolio/image5.png";
import brandsdivider from "../../assets/portfolio/brandsdevider.png";
import handpointer from "../../assets/portfolio/handpointer.png";
import { Link } from "react-router-dom";
import FlowerImage from "component/FlowerImage";
import red from "../../assets/flower/redd.png";
import castleImage from "../../assets/about/sideimage.png";

const Newportfolio = () => {
  return (
    <>
      <FlowerImage
        src={red}
        top={{ base: "16%", md: "10%" }}
        right={{ base: "10%", md: "20%" }}
      />

      <Box
        bg="#F4EDDC"
        py={10}
        px={{ base: 4, md: 20 }}
        overflow="hidden"
        position="relative"
      >
        {/* Castle Image */}
        <Box
          position="absolute"
          top={{ base: "57%", md: "auto" }}
          bottom={{ base: "auto", md: "0" }}
          left="0"
          w={{ base: "110%", md: "35%" }}
          zIndex={{ base: 0, md: 0 }}
        >
          <Image
            src={castleImage}
            alt="Castle Illustration"
            objectFit="cover"
            w="100%"
            h={{ base: "500px", md: "auto" }}
            maxH="100%"
            transform="scaleX(-1)"
          />
        </Box>

        {/* Text Section */}
        <Flex
          direction="column"
          align="center"
          justify="center"
          textAlign="center"
          px={4}
          maxW="800px"
          mx="auto"
          zIndex={1}
          mt={{ base: "0", md: 0 }}
        >
          <Text
            fontSize={{ base: "md", md: "xl" }}
            fontStyle="italic"
            fontWeight="bold"
            className="fade-in-up"
          >
            Our treasure
          </Text>
          <Heading
            fontSize={{ base: "2xl", md: "4xl" }}
            color="#C1A082"
            mt={2}
            className="fade-in-up"
          >
            A Showcase of Excellence
          </Heading>
          <Text
            mt={4}
            fontSize={{ base: "sm", md: "md" }}
            color="gray.700"
            className="fade-in-up"
          >
            Our portfolio is a testament to the Marwadi spirit where creativity
            meets smart strategy, and every project is handled with care and
            precision. From bold branding to dynamic websites, we’ve helped
            countless brands transform their vision into reality. Each project
            is a unique blend of tradition and innovation, crafted to deliver
            results that not only meet but exceed expectations.
          </Text>
          <Text
            mt={3}
            fontSize={{ base: "sm", md: "md" }}
            color="gray.700"
            className="fade-in-up"
          >
            Take a journey through our work and see how we bring ideas to life
            with the hustle, heart, and heritage that define us
          </Text>
        </Flex>

        {/* Browse Text */}
        <Box
          textAlign="center"
          mt={{ base: 12, md: 16 }}
          mb={8}
          px={{ base: 2, md: 0 }}
        >
          <Text
            fontSize={{ base: "md", md: "3xl" }}
            fontStyle="italic"
            fontWeight="bold"
            className="fade-in-up"
            color="#BFA585"
          >
            Browse our awesome work
          </Text>
        </Box>

        {/* Card Grid */}
        <Box
          pl={{ base: 0, md: "32%" }}
          pr={{ base: 0, md: 10 }}
          mt={{ base: 0, md: 0 }}
          zIndex={1}
          position="relative"
        >
          <SimpleGrid
            columns={{ base: 2, md: 4 }}
            spacing={{ base: 2, md: 4 }}
            justifyItems="center"
            width="100%"
          >
            {[
              { img: brandingImg, label: "Branding Portfolio" },
              { img: marketingImg, label: "Marketing Portfolio" },
              { img: websiteImg, label: "Website Portfolio" },
              { img: applicationImg, label: "Application Portfolio" },
            ].map((item, index) => (
              <Link
                to="/our-work"
                state={{ selectedTabLabel: item.label.split(" ")[0] }}
                key={index}
              >
                <Box
                  position="relative"
                  w={{ base: "100%", md: "98%" }}
                  maxW={{ md: "200px" }}
                  h={{ base: "150px", md: "274px" }}
                  maxH={{ base: "150px", md: "274px" }}
                  bg="#F4EDDC"
                  borderRadius="md"
                  overflow="hidden"
                  px={{ base: 1, md: 0 }}
                >
                  <Image
                    src={item.img}
                    alt={item.label}
                    width="100%"
                    height="100%"
                    objectFit="cover"
                    className="fade-in-up"
                    sx={{   mixBlendMode: {
                      base: "darken",
                      md: "darken"  
                    } }}
                  />
                  <Text
                    position="absolute"
                    top="50%"
                    left="50%"
                    transform="translate(-50%, -50%)"
                    color="white"
                    fontSize={{ base: "xs", md: "lg" }}
                    fontWeight="bold"
                    textAlign="center"
                    width="100%"
                    px={2}
                  >
                    {item.label}
                  </Text>
                </Box>
              </Link>
            ))}
          </SimpleGrid>
        </Box>
      </Box>

      <Box
        width="100%"
        bg="#004F6E"
        color="white"
        px={0}
        py={0}
        position="relative"
        zIndex={1}
        overflowX="hidden"
      >
        <Flex
          direction={{ base: "column", md: "row" }}
          justify="space-between"
          align="center"
          maxW="1100px"
          mx="auto"
          py={{ base: 8, md: 8 }}
          px={{ base: 4, md: 0 }}
          gap={{ base: 6, md: 4 }}
        >
          <Flex
            direction="row"
            align="center"
            justify={{ base: "center", md: "flex-start" }}
            gap={2}
            textAlign="left"
          >
            <Text
              fontSize={{ base: "md", md: "lg" }}
              fontWeight="bold"
              className="fade-in-up"
            >
              Say Hello
            </Text>
            <Text
              fontSize={{ base: "md", md: "lg" }}
              fontWeight="bold"
              fontStyle="italic"
              color="#BFA585"
              className="fade-in-up"
            >
              +98766544341
            </Text>
          </Flex>

          <Text
            fontSize={{ base: "md", md: "lg" }}
            fontWeight="bold"
            className="fade-in-up"
          >
            Let's work together
          </Text>

          <Box position="relative">
            <Button
              bg="#9D8A74"
              color="white"
              px={{ base: 5, md: 6 }}
              py={{ base: 3, md: 4 }}
              borderRadius="xl"
              fontWeight="semibold"
              fontSize={{ base: "xs", md: "sm" }}
              _hover={{ bg: "#BFA585" }}
            >
              Connect with Us
            </Button>
            <Image
              src={handpointer}
              alt="Hand Pointer"
              boxSize={{ base: "18px", md: "25px" }}
              position="absolute"
              right="-10px"
              bottom="-10px"
            />
          </Box>
        </Flex>

        <Box mt={{ base: 6, md: 4 }}>
          <Image
            src={brandsdivider}
            alt="Divider"
            width="100%"
            objectFit="cover"
            display="block"
          />
        </Box>
      </Box>
    </>
  );
};

export default Newportfolio;
